import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TenantService } from "projects/shared/src/lib/services/tenant.service";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridProjectsSettings {


  lastClicked: any;
  onRowClicked: any;

  constructor(
    private translate: TranslateService,
    private tenantService: TenantService,
    private deletable: boolean,
    private cloneable: boolean) {
   }

  
  
   public agGridProjectsSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 55,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 100,
    maxBlocksInCache: 10, // how many pages to store in cache. default is undefined, which allows an infinite sized cache, pages are never purged. this should be set for large data to stop your browser from getting full of data
    infiniteInitialRowCount: 0,
    columnDefs: [
      // { field: 'name', headerName: "Projects", sortable: true, filter: true},control_point_duplicate 
      //   { field: 'display_Name', headerName: "Projects", sortable: true, filter: true},
      { field: 'display_Name', headerName: `${this.translate.data["PROJECTSCOLUMNHEADER"]}`, sortable: true, filter: true },
      {
        headerName: `${this.translate.data["PROJECTSACTIONSCOLUMNHEADER"]}`,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          icon_edit: 'edit',
          // icon_clone:'file_copy',
          icon_clone: (this.cloneable)?'control_point_duplicate':"",
          icon_delete: (this.deletable)?'delete':"",
          routerLinkEditProject: (params: ICellRendererParams) => `/${this.tenantService.currentTenantName}/manage-projects/${_.get(params, 'data.id')}`,
          //onClick: (rowData: any) => this.handleRowClick(rowData)
          // routerLinkEditProject: (params: ICellRendererParams) => `/AARON/manage-projects/${_.get(params, 'data.id')}`
        }
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  
  }
}